import './couponsdetail.css';
import CouponImage from "@/assets/imgs/coupon_image.png"

export const CouponDetailModal = ({ coupon, onClose }) => {
  if (!coupon) return null;

  return (
    <div className="coupons-modal-detail-overlay" onClick={onClose}>
      <div
        className="coupons-modal-detail"
        onClick={(e) => e.stopPropagation()} // para que no se cierre si hacen click dentro
      >
        <button className="coupons-modal-detail-close" onClick={onClose}>
          &times;
        </button>

        <div className="coupons-modal-detail-content">
          <img
            src={CouponImage}
            alt={coupon.title}
            className="coupons-modal-detail-image"
          />

          <div className="coupons-modal-detail-info">
            <h2>{coupon.title}</h2>

            <div className="coupons-modal-detail-tags">
              {/* <span className="discount">{coupon.discount}</span> */}
              <span className="discount">-80% Dscto</span>
              <span className="condition">{coupon.condition}</span>
            </div>

            <p className="coupons-modal-detail-expiration">
              Cupón válido hasta el {coupon.expiration}
            </p>

            <p className="coupons-modal-detail-description">{coupon.description}</p>
            <p className="coupons-modal-detail-availability">
              ¡Disponible para uso en todas las tiendas!
            </p>

            <button className="coupons-modal-detail-activate">
              Activar cupón
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

